<template>
  <v-card class="pa-0 text-center" rounded="md" outlined>
    <v-card-title v-if="account.logo" :style="`border-top: 3px solid ${colorBackground ? colorBackground : account.color_background}`">
      <v-row justify="center">
        <v-sheet class="overflow-hidden" width="90" rounded="lg" outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="90">
              <v-img :src="account.logo.split(/[?#]/)[0]" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col class="pb-0 text-center" cols="12">
          <span class="d-block subtitle-1 font-weight-medium mt-1">Tienes {{counter}} facturas pendientes de pago por un total de {{sum | currency(instance.currency)}} {{instance.currency}}</span>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-divider />
    <v-card-text class="py-0 background">
      <v-row>
        <v-col class="pa-0" cols="12">
          <v-textarea class="elevation-0" v-model="messageBody" @input="updateMessage($event)" :placeholder="placeholder" background-color="background" auto-grow solo flat hide-details />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-simple-table class="mb-1 v-sheet--outlined rounded">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left background pa-2 subtitle-2" style="border-radius:8px 0 0 0">Factura</th>
                  <th class="text-right background pa-2 subtitle-2" style="width:100px">Total</th>
                  <th class="text-right background pa-2 subtitle-2" style="width:100px">Vencimiento</th>
                  <th class="text-right background pa-2 subtitle-2" style="border-radius:0 8px 0 0"></th>
                </tr>
              </thead>
              <tbody class="text--primary">
                <tr class="no-hover" v-for="i in invoices" :key="i.id">
                  <td class="text-left pa-2">{{i.document.name}}<br />Nº {{i.number}}</td>
                  <td class="text-right pa-2" style="width:100px">{{i.payments[0].balance | currency(i.currency)}} {{i.currency}}</td>
                  <td class="text-right pa-2" style="width:100px">{{i.due_date | date}}</td>
                  <td class="text-right pa-2">
                    <v-btn :style="`background-color:${colorBackground ? colorBackground : account.color_background};`" height="32" dark small :ripple="false">Pagar</v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import ReminderViewMixin from '@/mixins/ReminderViewMixin'
export default {
  mixins: [
    ReminderViewMixin
  ],
  data: () => ({
    counter: null,
    invoices: [],
    loader: false,
    sum: null
  }),
  created () {
    this.loader = true

    this.$store.dispatch('invoices/LIST', {
      resource: 'invoices',
      query: {
        customer: this.instance.id,
        status: 'finalized'
      },
      setState: false
    })
    .then((response) => {
      this.counter = response.data.count
      this.invoices = response.data.results

      this.sum = this.sumProperty(this.invoices, 'payments.balance')
    })
    .finally(() => {
      this.loader = false
    })
  }
}
</script>